<template>
 <div>
  <Card>
   <div slot="title" v-if="toDoStage!=='assign_transport_vehicle'"><span style="font-weight: bolder;font-size: 18px">Available Tempo/Truck</span>
    <RadioGroup v-model="vehicleType" type="button" style="float: right;margin: -5px" size="small">
     <Radio label="tempo">TEMPO</Radio>
     <Radio label="truck">TRUCK</Radio>
    </RadioGroup>
   </div>

   <template v-if="toDoStage!=='assign_transport_vehicle'">
    <TempoAssignment v-if="vehicleType === 'tempo'" :orderDetailObj="orderDetailObj"
                     ref="tempo-assignment"></TempoAssignment>
   </template>

    <TruckAssignment v-if="vehicleType === 'truck'" :orderDetailObj="orderDetailObj" :toDoStage="toDoStage"
                     ref="truck-assignment"></TruckAssignment>

  </Card>

   <Button style="margin-top: 15px" @click="updateOrder" v-if="!isComponentLoadedInToDo">Tempo Sent For Pickup</Button>
 </div>
</template>

<script>
import {GET_ORDER_DETAIL_FOR_VEHICLE} from '../../graphql/queries/OrderDetails'
import {SUBSCRIBE_ORDER_DETAIL_FOR_VEHICLE} from '../../graphql/subscription/orderDetails'
import {UPDATE_ORDER_BY_STATUS} from '../../graphql/mutations/orders'
import TempoAssignment from './TempoAssignment'
import TruckAssignment from './TruckAssignment'
    export default {
        apollo:{
            orderDetails: {
                query: GET_ORDER_DETAIL_FOR_VEHICLE,
                variables() {
                    return {
                        orderId: this.orderId
                    }
                },
                subscribeToMore: {
                    document: SUBSCRIBE_ORDER_DETAIL_FOR_VEHICLE,
                    variables() {
                        return {
                            orderId: this.orderId
                        }
                    },
                    updateQuery: function(previousResult, { subscriptionData }) {
                        if (subscriptionData.data.orderDetails.length) {
                            this.orderDetailObj = subscriptionData.data.orderDetails[0]
                        }
                    },
                },
                result({data, loading}) {
                    if (!loading && data.orderDetails.length) {
                            this.orderDetailObj = data.orderDetails[0]
                    }
                }
            }
        },
        name: "VehicleAssignment",
        components: {TempoAssignment, TruckAssignment},
        props:['orderId', 'isComponentLoadedInToDo', 'vehicleTypeInToDo', 'toDoStage'],
        inject: ["setManageOrderDrawer"],
        data:function(){
            return{
                mutation_UPDATE_ORDER_BY_STATUS: UPDATE_ORDER_BY_STATUS,
                vehicleType:'tempo',
                orderDetailObj: {},
            }
        },
        watch: {
          // 'vehicleTypeInToDo':function(val){
          //     if(val){
          //         this.vehicleType = val
          //     }
          //   }
        },
        created(){
            if(this.toDoStage==='assign_transport_vehicle'){
                this.vehicleType = 'truck'
                console.log('vehicleType changed')
            }
        },
        methods: {
           reset(){
             if(this.vehicleType === 'tempo'){
                 this.$refs['tempo-assignment'].reset();
             }else{
                 this.$refs['truck-assignment'].reset();
             }
           },
            async updateOrder(){
                let response = await this.$apollo.mutate({
                    mutation: this.mutation_UPDATE_ORDER_BY_STATUS,
                    variables: {
                        orderId: this.orderId,
                        internalstatus: 'ccefb0de-fc2b-4a46-8e3f-996f04f40351',  //Change internalStatusId to 'Tempo On The Way To Pickup Load'
                    }
                })
                if(response.data){
                    this.$Message.success('Order updated successfully!');
                    this.setManageOrderDrawer(false)
                }
            },
        }
    }
</script>

<style scoped>

</style>